import React, { useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { SidebarData, SidebarDataForAllCompanies } from "../../core/json/siderbar_data";
import { loggedInUser } from "core/redux/slice/authSlice";
import { hasPermission } from "core/Operations/checkPermission";

import HorizontalSidebar from "./horizontalSidebar";
import CollapsedSidebar from "./collapsedSidebar";

const Sidebar = () => {
  const userData = useSelector(loggedInUser);
  const permissions = userData?.permissions || [];

  const location = useLocation();
  const navigate = useNavigate();

  const [openMenu, setOpenMenu] = useState("");
  const [openSubMenu, setOpenSubMenu] = useState("");

  /* -------------------- HELPERS -------------------- */

  const safeNavigate = (path) => {
    if (!path || path === "#") return;

    navigate({
      pathname: path,
      search: "", //location.search,
    });
  };

  const isActive = (path) => location.pathname === path;
  const isStartsWith = (path) => location.pathname.startsWith(path);

  /* -------------------- PERMISSION HELPERS -------------------- */

  const hasAnyChildAccess = (group) => {
    // if (!group?.submenuItems?.length) return false;

    return group.some((item) =>
      hasPermission(
        permissions,
        item.accessCode, // ✅ use child accessCode
        "",
        "haveView"
      )
    );
  };

  /* -------------------- TOGGLES -------------------- */

  const toggleMenu = (label) =>
    setOpenMenu((prev) => (prev === label ? "" : label));

  const toggleSubMenu = (label) =>
    setOpenSubMenu((prev) => (prev === label ? "" : label));

  /* -------------------- RENDER -------------------- */

  return (
    <div>
      <div className="sidebar" id="sidebar">
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                {userData?.isAllCompanies ? SidebarDataForAllCompanies.map((module, moduleIndex) => {
                  // 🔒 HIDE MODULE IF NO CHILD ACCESS
                  // if (!hasAnyChildAccess(module)) return null;

                  return (
                    <li key={moduleIndex} className="submenu-open">
                      <h6 className="submenu-hdr">{module.label}</h6>

                      <ul>
                        {module.submenuItems.map((menu, menuIndex) => {
                          const canViewMenu = hasPermission(
                            permissions,
                            menu.accessCode,
                            "",
                            "haveView"
                          );

                          if (!canViewMenu) return null;

                          return (
                            <li key={menuIndex} className="submenu">
                              {/* LEVEL 1 */}
                              <a
                                role="button"
                                className={`${
                                  openMenu === menu.label ? "subdrop" : ""
                                } ${
                                  isActive(menu.link) || isStartsWith(menu.link)
                                    ? "active"
                                    : ""
                                }`}
                                onClick={() => {
                                  toggleMenu(menu.label);
                                  safeNavigate(menu.link);
                                }}
                              >
                                {menu.icon}
                                <span>{menu.label}</span>
                                <span className="menu-arrow" />
                              </a>

                              {/* LEVEL 2 */}
                              {menu.submenuItems && (
                                <ul
                                  style={{
                                    display:
                                      openMenu === menu.label
                                        ? "block"
                                        : "none",
                                  }}
                                >
                                  {menu.submenuItems.map((sub, subIndex) => {
                                    if (sub.accessCode === "Master") {
                                      if (!hasAnyChildAccess(menu.submenuItems))
                                        return null;
                                    } else {
                                      const canViewSub = hasPermission(
                                        permissions,
                                        menu.accessCode,
                                        sub.accessCode,
                                        "haveView"
                                      );

                                      if (!canViewSub) return null;
                                    }

                                    return (
                                      <li
                                        key={subIndex}
                                        className="submenu submenu-two"
                                      >
                                        <a
                                          role="button"
                                          className={
                                            isActive(sub.link) ||
                                            isStartsWith(sub.link)
                                              ? "active"
                                              : ""
                                          }
                                          onClick={() => {
                                            toggleSubMenu(sub.label);
                                            safeNavigate(sub.link);
                                          }}
                                        >
                                          {sub.label}
                                          {sub.submenu && (
                                            <span className="menu-arrow" />
                                          )}
                                        </a>

                                        {/* LEVEL 3 */}
                                        {sub.submenuItems && (
                                          <ul
                                            style={{
                                              display:
                                                openSubMenu === sub.label
                                                  ? "block"
                                                  : "none",
                                            }}
                                          >
                                            {sub.submenuItems.map(
                                              (leaf, leafIndex) => {
                                                const canViewLeaf =
                                                  hasPermission(
                                                    permissions,
                                                    sub.accessCode,
                                                    leaf.accessCode,
                                                    "haveView"
                                                  );

                                                if (!canViewLeaf) return null;
                                                return (
                                                  <li key={leafIndex}>
                                                    <a
                                                      role="button"
                                                      className={
                                                        isActive(leaf.link)
                                                          ? "active submenu-two"
                                                          : "submenu-two"
                                                      }
                                                      onClick={() =>
                                                        safeNavigate(leaf.link)
                                                      }
                                                    >
                                                      {leaf.label}
                                                    </a>
                                                  </li>
                                                );
                                              }
                                            )}
                                          </ul>
                                        )}
                                      </li>
                                    );
                                  })}
                                </ul>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    </li>
                  );
                }) :  SidebarData.map((module, moduleIndex) => {
                  // 🔒 HIDE MODULE IF NO CHILD ACCESS
                  // if (!hasAnyChildAccess(module)) return null;

                  return (
                    <li key={moduleIndex} className="submenu-open">
                      <h6 className="submenu-hdr">{module.label}</h6>

                      <ul>
                        {module.submenuItems.map((menu, menuIndex) => {
                          const canViewMenu = hasPermission(
                            permissions,
                            menu.accessCode,
                            "",
                            "haveView"
                          );

                          if (!canViewMenu) return null;

                          return (
                            <li key={menuIndex} className="submenu">
                              {/* LEVEL 1 */}
                              <a
                                role="button"
                                className={`${
                                  openMenu === menu.label ? "subdrop" : ""
                                } ${
                                  isActive(menu.link) || isStartsWith(menu.link)
                                    ? "active"
                                    : ""
                                }`}
                                onClick={() => {
                                  toggleMenu(menu.label);
                                  safeNavigate(menu.link);
                                }}
                              >
                                {menu.icon}
                                <span>{menu.label}</span>
                                <span className="menu-arrow" />
                              </a>

                              {/* LEVEL 2 */}
                              {menu.submenuItems && (
                                <ul
                                  style={{
                                    display:
                                      openMenu === menu.label
                                        ? "block"
                                        : "none",
                                  }}
                                >
                                  {menu.submenuItems.map((sub, subIndex) => {
                                    if (sub.accessCode === "Master") {
                                      if (!hasAnyChildAccess(menu.submenuItems))
                                        return null;
                                    } else {
                                      const canViewSub = hasPermission(
                                        permissions,
                                        menu.accessCode,
                                        sub.accessCode,
                                        "haveView"
                                      );

                                      if (!canViewSub) return null;
                                    }

                                    return (
                                      <li
                                        key={subIndex}
                                        className="submenu submenu-two"
                                      >
                                        <a
                                          role="button"
                                          className={
                                            isActive(sub.link) ||
                                            isStartsWith(sub.link)
                                              ? "active"
                                              : ""
                                          }
                                          onClick={() => {
                                            toggleSubMenu(sub.label);
                                            safeNavigate(sub.link);
                                          }}
                                        >
                                          {sub.label}
                                          {sub.submenu && (
                                            <span className="menu-arrow" />
                                          )}
                                        </a>

                                        {/* LEVEL 3 */}
                                        {sub.submenuItems && (
                                          <ul
                                            style={{
                                              display:
                                                openSubMenu === sub.label
                                                  ? "block"
                                                  : "none",
                                            }}
                                          >
                                            {sub.submenuItems.map(
                                              (leaf, leafIndex) => {
                                                const canViewLeaf =
                                                  hasPermission(
                                                    permissions,
                                                    sub.accessCode,
                                                    leaf.accessCode,
                                                    "haveView"
                                                  );

                                                if (!canViewLeaf) return null;
                                                return (
                                                  <li key={leafIndex}>
                                                    <a
                                                      role="button"
                                                      className={
                                                        isActive(leaf.link)
                                                          ? "active submenu-two"
                                                          : "submenu-two"
                                                      }
                                                      onClick={() =>
                                                        safeNavigate(leaf.link)
                                                      }
                                                    >
                                                      {leaf.label}
                                                    </a>
                                                  </li>
                                                );
                                              }
                                            )}
                                          </ul>
                                        )}
                                      </li>
                                    );
                                  })}
                                </ul>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>

      <HorizontalSidebar />
      <CollapsedSidebar />
    </div>
  );
};

export default Sidebar;
